import { Constants } from 'common/config/constants'
import { LocalizedStringsMethods } from './types/string-types'

export type LanguageContent = typeof defaultContent

export type LocalizedStrings = LocalizedStringsMethods & LanguageContent

type StringsSingleton = {
  instance: LocalizedStrings | undefined
}

const defaultContent = {
  404: 'Request item not found',
  defaultErrorMessage: 'An unexpected error has occurred',
  disabled: 'Disabled',
  hello: 'Hello',
  home: 'Home',
  link: 'Link',
  login: 'Login',
  pleaseSelect: 'Please Select',
  search: 'Search',
}

const strings: StringsSingleton = {
  instance: undefined,
}

const getStrings: () => LocalizedStrings = () => {
  if (!strings.instance) {
    throw new Error(
      'Strings is not initialized. Make sure Web or Mobile sets strings.instance',
    )
  }
  return strings.instance
}

const setStrings = (stringsParam: LocalizedStrings) => {
  strings.instance = stringsParam
  initBlobby()
}

const stringRecords: Record<string, LanguageContent> = {
  de: {
    404: 'Request item not found(de)',
    defaultErrorMessage: 'An unexpected error has occurred(de)',
    disabled: 'Disabled(de)',
    hello: 'Hello(de)',
    home: 'Home(de)',
    link: 'Link(de)',
    login: 'Login(de)',
    pleaseSelect: 'Please Select(de)',
    search: 'Search(de)',
  },
  en: defaultContent,
}

const initBlobby = () => {
  if (Constants.simulate.FORCE_LANGUAGE === 'blobby') {
    const blobby = {} as LanguageContent
    Object.keys(defaultContent).map((key) => {
      // @ts-ignore
      const val = defaultContent[key]
      const words = val.split(' ')
      let idx = 0
      const newWordsBlobby = words.map((word: string, index: number) => {
        const arr = ['eeeee', 'blob', 'blobby', 'wuueeeeh']

        if (idx === arr.length - 1) {
          idx = 0
        } else {
          idx++
        }
        if (word.indexOf('{') !== -1) {
          // reserve params
          return word
        }
        return arr[index]
      })
      blobby[key as keyof LanguageContent] = `${newWordsBlobby
        .join(' ')
        .trim()}`
    })
    stringRecords.blobby = blobby
  }
}

export { stringRecords, getStrings, setStrings }
